import { Facebook, Instagram, Linkedin } from "lucide-react";

export const navLinks = [
  { label: "Home", href: "/#home" },
  { label: "Serviços", href: "/#servicos" },
  { label: "Sobre", href: "/#sobre" },
  { label: "Planos", href: "/#planos" },
  { label: "Contato", href: "/#contato" },
];

export const socialLinks = [
  {
    href: "https://www.facebook.com/seuperfil",
    icon: Facebook,
  },
  {
    href: "https://www.instagram.com/somosgrupom2",
    icon: Instagram,
  },
  {
    href: "https://www.linkedin.com/in/seuperfil",
    icon: Linkedin,
  },
];
